"use client";

import useLocaleRouter from "@/hooks/useLocaleRouter";
import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { CircleX, Search } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function SearchInput() {
  const searchParams = useSearchParams();
  const keyword = searchParams.get("keyword");
  const t = useScopedI18n("全局搜索");
  const [searchValue, setSearchValue] = useState(keyword || "");

  // 监听searchParams变化，同步更新searchValue
  useEffect(() => {
    const newKeyword = searchParams.get("keyword");
    setSearchValue(newKeyword || "");
  }, [searchParams]);

  const router = useLocaleRouter();

  return (
    <div className="mb-6 flex items-center justify-center md:mb-10 lg:mb-14">
      <div className="relative flex h-8 w-full items-center overflow-hidden rounded-2xl border border-[#E5E5E5] bg-white transition-colors duration-300 focus-within:border-primary md:h-[3.25rem] md:w-3/4 md:rounded-md md:border-[#A6A6A6] lg:w-1/2">
        <input
          type="text"
          className="h-full w-full pl-5 text-sm outline-none placeholder:text-sm placeholder:text-[#8A8A8A] md:pl-7 md:text-xl md:placeholder:text-xl"
          placeholder={t("汽车")}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              router.push(`/global-search?keyword=${searchValue}`, {
                scroll: false,
              });
            }
          }}
        />

        <div className="flex items-center pr-3">
          <div
            className={cn(
              "pointer-events-none px-2 text-[#BFBFBF] opacity-0 transition-all duration-300 md:text-[#8A8A8A]",
              {
                "pointer-events-auto cursor-pointer opacity-100 hover:text-primary":
                  searchValue.length > 0,
              }
            )}
            onClick={() => {
              setSearchValue("");
            }}>
            <CircleX className="hidden md:block" size={20} />
            <CircleX className="md:hidden" size={16} />
          </div>
          <div className="h-3 w-px bg-[#BFBFBF] md:h-6 md:bg-[#8A8A8A]"></div>
          <div
            className="cursor-pointer px-2 text-[#BFBFBF] transition-colors duration-300 hover:text-primary md:text-[#8A8A8A]"
            onClick={() => {
              router.push(`/global-search?keyword=${searchValue}`);
            }}>
            <Search className="hidden md:block" size={20} />
            <Search className="md:hidden" size={16} />
          </div>
        </div>
      </div>
    </div>
  );
}
